module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.instantwins', {
            url: '/instant-wins',
            data: {
                analytics: `bws:web:instant-wins`,
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata({ name: 'instant wins - BWS Online' });
                    }
                ]
            },
            views: {
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        });
    };


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/instantwins.js
 **/